import { render } from "./SignInComponent.vue?vue&type=template&id=6c2030c0"
import script from "./SignInComponent.vue?vue&type=script&lang=js"
export * from "./SignInComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__